import React, { useState, useEffect, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import './gallery.css';


const galleryImages = [
  { src: require('../../asstes/images/Image 1.jpeg'), caption: "Wycliffe, CEO – DSCHOOL World of Learning, Kenya" },
  { src: require('../../asstes/images/Image 2.jpeg'), caption: "Wycliffe, CEO – DSCHOOL World of Learning, Kenya" },
  { src: require('../../asstes/images/image 100.jpg'), caption: 'Dr. Elizabeth Islas, CEO - Nelkuali' },
  { src: require('../../asstes/images/image 101.jpeg'), caption: 'Anand & Mahendra - Britewissen' },
  { src: require('../../asstes/images/Associated image.jpeg'), caption: 'Sibrand Poppema PRESIDENT - Sunway University, Malaysia' },
  { src: require('../../asstes/images/Lincoln.jpeg'), caption: 'Prof. Dr. Amiya Bhaumik, CEO - Lincoln University College, Malaysia' },
  { src: require('../../asstes/images/Gkk.jpeg'), caption: 'Gajendra Balasingham Founder - GKK Consultants, Malaysia' },
  { src: require('../../asstes/images/Andhra pradesh.jpeg'), caption: 'Andhra Pradesh Public Library' },
  { src: require('../../asstes/images/Andhra.jpeg'), caption: 'Andhra Pradesh Residential School - Tadikonda' }
];

function Gallery() {

  const [activeIndex, setActiveIndex] = useState(null);

  const isOpen = activeIndex !== null;

  const closeLightbox = useCallback(() => setActiveIndex(null), []);

  const showPrev = useCallback(() => {
    setActiveIndex((i) => (i === 0 ? galleryImages.length - 1 : i - 1));
  }, []);

  const showNext = useCallback(() => {
    setActiveIndex((i) => (i === galleryImages.length - 1 ? 0 : i + 1));
  }, []);


  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === 'ArrowLeft') showPrev();
      else if (e.key === 'ArrowRight') showNext();
    };

    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, closeLightbox, showPrev, showNext]);

  return (
    <>
      <section className='InnerPBanSec GalleryPage'>
        <div className='IPBBgimg'>
          <img src={require('../../asstes/images/aboutBanBg.jpg')} alt="" />
        </div>
        <div className='BanContSec'>
          <Container>
            <div className='textBlack' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>

              <h1>What We Built Together</h1>
              <p style={{ marginTop: '20px', color: 'white', fontSize: '24px' }}>
                UEDUCATE thrives on strategic partnerships nationwide. Walk through our visual history below to see how we are turning the vision of transformed education into reality.
              </p>
            </div>
          </Container>
        </div>
      </section>
      <section className='aboutIntrosec'>
        <Container>

          {/* <div className='textBlack tbTitle'> */}

          {/* <h2 data-aos="fade-down" data-aos-duration="1000">What We Built <span>Together</span></h2>

          </div>

          <p style={{ marginTop: '20px' }}>
            UEDUCATE thrives on strategic university partnerships nationwide. Walk through our visual history below to see how we are turning the vision of transformed education into reality.
          </p> */}


          {/* <div className="galleryHeading">
          <h1>Partner <span style={{color:'#3ab2cc'}}>Institutions</span></h1>
          <p>UEDUCATE drives global educational innovation by partnering with leading universities through its Collaborative Program for diverse academic disciplines</p>
        </div> */}
          {/* <div className="bpSecHead">
            <h2>What We Built </h2>
            {/* <h2>What We Built Together</h2>
                        <p>Browse our partners grouped by their referencer. Click a referencer to view the partners.</p> */}
          {/* <p>UEDUCATE thrives on strategic university partnerships nationwide. Walk through our visual history below to see how we are turning the vision of transformed education into reality.</p>
          </div> */}

          <div className="galleryGrid">
            {galleryImages.map((item, index) => (
              <button
                type="button"
                className="galleryGridItem"
                key={index}
                onClick={() => setActiveIndex(index)}
              >
                <img src={item.src} alt={item.caption} loading="lazy" />
                <span className="galleryGridOverlay">
                  {item.caption && (
                    <span className="galleryGridCaption">{item.caption}</span>
                  )}
                </span>
              </button>
            ))}
          </div>
        </Container>

        {isOpen && (
          <div className="galleryLightbox">
            <button
              type="button"
              className="glClose"
              onClick={closeLightbox}
              aria-label="Close"
            >
              &times;
            </button>

            <button
              type="button"
              className="glArrow glArrowPrev"
              onClick={(e) => {
                e.stopPropagation();
                showPrev();
              }}
              aria-label="Previous"
            >
              <span>&#8249;</span>
            </button>

            <div className="glContent" onClick={(e) => e.stopPropagation()}>
              <img src={galleryImages[activeIndex].src} alt={galleryImages[activeIndex].caption} />
              {galleryImages[activeIndex].caption && (
                <div className="glCaption">{galleryImages[activeIndex].caption}</div>
              )}
            </div>

            <button
              type="button"
              className="glArrow glArrowNext"
              onClick={(e) => {
                e.stopPropagation();
                showNext();
              }}
              aria-label="Next"
            >
              <span>&#8250;</span>
            </button>
          </div>
        )}
      </section>
    </>
  );
}

export default Gallery;
